var FeedbackOfferSku;
(function (FeedbackOfferSku) {
    FeedbackOfferSku["AppleAppstore"] = "apple-appstore-feedback";
    FeedbackOfferSku["FacebookAd"] = "facebook-ad-feedback";
    FeedbackOfferSku["General"] = "general-feedback";
    FeedbackOfferSku["GooglePlaystore"] = "google-playstore-feedback";
    FeedbackOfferSku["SentinelXBLEReview"] = "sentinelx-ble-review";
    FeedbackOfferSku["SentinelXNFCReview"] = "sentinelx-nfc-review";
})(FeedbackOfferSku || (FeedbackOfferSku = {}));
export default FeedbackOfferSku;
//# sourceMappingURL=FeedbackOfferSku.js.map